import React from 'react';
import AppRoutes from './Approutes';
import { HelmetProvider } from 'react-helmet-async';




function App() {
  return (
      <HelmetProvider>
        <AppRoutes />
      </HelmetProvider>
  );
}

export default App;
